





































































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import { GetListByCode } from "@/api/configureDictionary";
import { InsertEducationPlanAssess,UpdateEducationPlanAssess,QueryEducationPlanAssess} from "@/api/pdEducationPlan/pdPatientEducationPlan";
@Component({})
export default class PDPatientEducationPlanAssess extends AbpBase {
  @Prop() pdPatientEducationPlan: any;
  PatientEducationPlan: any = {};
  EducationPlanAssess: any = {};
  PlanRealize: any[] = [];
  PlanLanguage: any[] = [];
  PlanShaky: any[] = [];
  PlanTakeCare: any[] = [];
  PlanVision: any[] = [];
  PlanHearing: any[] = [];
  PlanCognition: any[] = [];
  PlanCharge: any[] = [];
  rules = {};

  @Watch("pdPatientEducationPlan")
  async onPipeChanged() {
    if (this.pdPatientEducationPlan) {
      var newObj = Object.assign({}, this.pdPatientEducationPlan);
      this.PatientEducationPlan = newObj;
    }
    let res = await QueryEducationPlanAssess(this.PatientEducationPlan);
    this.EducationPlanAssess = res.objects;
              console.log(res);
  }

  initDic() {
    GetListByCode({ input: "PD_Dic_Education_Plan_Realize" }).then(res => {
      this.PlanRealize = res;
    });
    GetListByCode({ input: "PD_Dic_Education_Plan_Language" }).then(res => {
      this.PlanLanguage = res;
    });

    GetListByCode({ input: "PD_Dic_Education_Plan_Shaky" }).then(res => {
      this.PlanShaky = res;
    });

    GetListByCode({ input: "PD_Dic_Education_Plan_Take_Care" }).then(res => {
      this.PlanTakeCare = res;
    });

    GetListByCode({ input: "PD_Dic_Education_Plan_Vision" }).then(res => {
      this.PlanVision = res;
    });

    GetListByCode({ input: "PD_Dic_Education_Plan_Hearing" }).then(res => {
      this.PlanHearing = res;
    });

    GetListByCode({ input: "PD_Dic_Education_Plan_Cognition" }).then(res => {
      this.PlanCognition = res;
    });

    GetListByCode({ input: "PD_Dic_Education_Plan_Medical_Charge" }).then(
      res => {
        this.PlanCharge = res;
      }
    );
  }

  async submit() {
    let validResult = false;
    this.$refs["form"].validate(valid => {
      if (valid) {
        validResult = true;
      }
    });
    if (validResult) {
      if (this.EducationPlanAssess.id == 0) {
        await InsertEducationPlanAssess(this.EducationPlanAssess);
      } else {
        await UpdateEducationPlanAssess(this.EducationPlanAssess);
      }

      return true;
    }

    return false;
  }

  constructor() {
    super();
    this.initDic();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdPatientEducationPlan/pdPatientEducationPlanAssess.vue